export default {
      id: "small-down-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#small-down",
      toString: function () {
        return this.url;
      }
    }